import { useState } from 'react';
import { useNavStore } from '../navStore';
import { Link } from 'react-router-dom';
import { useAuthStore } from '@/features/auth/store/authStore';
import { initials, fullName } from '@/utils/format';

export function Header() {
  const { user, logout } = useAuthStore();
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleNav = useNavStore(s => s.toggle);

  const name = user ? fullName(user) : '';
  const avi  = user ? initials(user.firstName, user.lastName) : '?';

  return (
    <header className="topbar layout__topbar">
      {/* Hamburger */}
      <button className="topbar__hamburger" aria-label="Toggle sidebar" onClick={toggleNav}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
          <line x1="3" y1="6"  x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </button>

      {/* Search */}
      <div className="topbar__search">
        <svg className="topbar__search-icon" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.35-4.35" />
        </svg>
        <input
          type="text"
          className="topbar__search-input"
          placeholder="Search Tickets, Assets, Users..."
          aria-label="Search"
        />
      </div>

      {/* Right actions */}
      <div className="topbar__right">
        {/* Mail */}
        <button className="topbar__action-btn" aria-label="Messages">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
            <polyline points="22,6 12,13 2,6" />
          </svg>
        </button>

        {/* Notifications */}
        <button className="topbar__action-btn" aria-label="Notifications">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
          </svg>
          <span className="topbar__badge">7</span>
        </button>

        <div className="topbar__sep" />

        {/* User dropdown */}
        {user && (
          <div className="dropdown">
            <button className="topbar__user" onClick={() => setMenuOpen(o => !o)} aria-label="User menu">
              <div className="avatar avatar--sm" style={{ background: '#e0e7ff', color: '#4f46e5', fontWeight: 700 }}>
                {user.avatarUrl ? <img src={user.avatarUrl} alt={name} /> : avi}
              </div>
              <div className="topbar__user-info">
                <div className="topbar__user-name">{name}</div>
                <div className="topbar__user-role">{user.role?.replace(/_/g, ' ')}</div>
              </div>
              <svg width="12" height="12" viewBox="0 0 20 20" fill="currentColor"
                style={{ color: 'var(--color-text-muted)', flexShrink: 0, marginLeft: '0.125rem' }}>
                <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
              </svg>
            </button>

            {menuOpen && (
              <>
                <div style={{ position: 'fixed', inset: 0, zIndex: 99 }} onClick={() => setMenuOpen(false)} />
                <div className="dropdown__menu" style={{ minWidth: '12rem', right: 0 }}>
                  <div style={{ padding: '0.625rem 0.75rem', borderBottom: '1px solid var(--color-border)', marginBottom: '0.25rem' }}>
                    <div style={{ fontWeight: 600, fontSize: '0.8125rem' }}>{name}</div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)' }}>{user.email}</div>
                    <div style={{ fontSize: '0.6875rem', color: 'var(--color-primary)', marginTop: '0.125rem', fontWeight: 600 }}>
                      {user.role?.replace(/_/g, ' ')}
                    </div>
                  </div>
                  <Link
                    to="/profile"
                    className="dropdown__item"
                    onClick={() => setMenuOpen(false)}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx="12" cy="7" r="4" />
                    </svg>
                    My Profile
                  </Link>
                  <button
                    className="dropdown__item dropdown__item--danger"
                    onClick={() => { setMenuOpen(false); logout(); }}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                      <polyline points="16 17 21 12 16 7" />
                      <line x1="21" y1="12" x2="9" y2="12" />
                    </svg>
                    Sign out
                  </button>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </header>
  );
}
